import loadBasketModule from './modules/Basket.module';
import loadCheckoutModule from './modules/Checkout.module';
const loadBasketMenuItemModule = () => ({
    hasRouter: false,
    modules: [loadBasketModule(), loadCheckoutModule()],
});
export default loadBasketMenuItemModule;
